import { MenuItem } from "../view-models/menu-item";
import {ReactComponent as Menu1Icon} from '../shared/images/svg/menu_1.svg'
import {ReactComponent as Menu2Icon} from '../shared/images/svg/menu_2.svg'
import {ReactComponent as Menu3Icon} from '../shared/images/svg/menu_3.svg'
import { links } from "../config/links";



export const menuItems: MenuItem[] = [
    new MenuItem(1, "Вернуться в каталог", "Почитать что-нибудь еще", <Menu1Icon/>, links.stories),
    new MenuItem(2, "Перейти в аккаунт", "Изменить данные, оплатить тариф", <Menu2Icon/>, links.profile),
    new MenuItem(3, "Выйти из аккаунта", "Уйти, чтобы вернуться", <Menu3Icon/>),

]